import queryString from 'query-string'
import { sizeRatioMap } from 'lemon-campaign-ui/lib/hoc/resize'

const maxWidth = 320

const optimizeImgix = (url, size) => {
  if (!url || !size) {
    return {}
  }

  const index = url.indexOf('?')
  if (index === -1) {
    url = `${url}?`
  }

  let [baseUrl, query] = url.split('?')

  const queryObj = queryString.parse(query)
  if (queryObj) {
    queryObj.w = maxWidth * 2

    if (size && sizeRatioMap[size]) {
      queryObj.h = (queryObj.w / sizeRatioMap[size]) * 2
    }

    // TODO: activate
    delete queryObj.w
    delete queryObj.h

    queryObj.auto = ['compress'].join(',')

    queryObj.fm = 'jpg'

    if (typeof window !== `undefined` && window.Modernizr.webp) {
      queryObj.fm = 'webp'
    }

    queryObj.q = 75
  }

  const buildUrl = ({ base = baseUrl, obj = queryObj } = {}) => {
    return `${base}?${queryString.stringify(obj)}`
  }

  return {
    baseUrl,
    queryObj,
    buildUrl,
    url: buildUrl(),
  }
}

export default optimizeImgix
